import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";

export function ForgotPasswordDialog() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [reply, setReply] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email, file_code: code });
      setReply(data.message);
    } catch (e2) {
      setErr(formatApiErrorDetail(e2?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const onOpenChange = (v) => {
    setOpen(v);
    if (!v) { setReply(""); setEmail(""); setCode(""); setErr(""); }
  };

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="text-xs underline underline-offset-4 text-zinc-600 hover:text-black" data-testid="forgot-password-link">
        ¿Olvidaste tu contraseña?
      </button>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="rounded-none border-2 border-black max-w-sm" data-testid="forgot-password-dialog">
          <DialogHeader>
            <DialogTitle className="font-display flex items-center gap-2"><Sparkles size={18} className="text-[#F5B301]" /> SofIA</DialogTitle>
            <DialogDescription>
              Hola, no puedo ver tu contraseña, pero te pongo con un supervisor para que la restablezca. Dime tu email y tu nº de expediente.
            </DialogDescription>
          </DialogHeader>
          {reply ? (
            <p className="text-sm bg-zinc-50 border-l-4 border-[#F5B301] p-3" data-testid="forgot-password-reply">{reply}</p>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Tu email de acceso" className="h-11 rounded-none border-black" data-testid="forgot-password-email" />
              <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" placeholder="Nº de expediente (6 dígitos)" className="h-11 rounded-none border-black" data-testid="forgot-password-code" />
              {err && <p className="text-xs text-red-700">{err}</p>}
              <Button type="submit" disabled={busy} className="w-full h-11 rounded-none bg-black hover:bg-[#E63946]" data-testid="forgot-password-submit">
                {busy && <Loader2 className="animate-spin mr-2" size={16} />} Avisar a un supervisor
              </Button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
